export enum TourStatus {
    IN_PROGRESS = 'in-progress',
    COMPLETED = 'completed'
}
